import React, { useState } from "react";
import Header from "../header/header";
import Footer from "../footer/footer";
import { useEffect } from "react";
import { getTermsAndCondition } from "../services";
import Skeleton from "../auth/component/skeleton";
import DOMPurify from "dompurify";
import Card from "../../components/card/card";
import { useNavigate } from "react-router-dom";
import { routerPath } from "../../navigation/path";

const About = () => {
  const [aboutUs, setAboutus] = useState({});
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    getAboutUs();
  }, []);

  const getAboutUs = async () => {
    try {
      const res = await getTermsAndCondition("about_us");
      console.log(res.data[0]);
      await setAboutus(res?.data[0]);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  const offerClick = (e) => {
    console.log("offer clicked", e);
    navigate(`${routerPath.claimOffer}?offer_id=${e.id}`);
  };
  return (
    <>
      <Header />
      <div className="grid grid-cols-1 bg-white">
        {loading ? (
          <>
            <div className="flex flex-col items-center bg-white shadow-md rounded-lg p-4">
              <Skeleton width="100%" />
            </div>
          </>
        ) : (
          <>
            <div className="grid grid-cols-1">
              <img src={aboutUs.image_url} alt="" />
            </div>
          </>
        )}

        <div className="container mx-auto">
          <h3 className="ps-2 mt-5 font-semibold">
            Line up of Special Offers worth Rs. 1,00,000 exclusively for You
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 py-3 gap-2">
            {loading ? (
              [1, 2, 3, 4].map((e, i) => (
                <div className="px-2 overflow-hidden py-2" key={e + i}>
                  <Skeleton />
                </div>
              ))
            ) : (
              <>
                {aboutUs.offer_details &&
                  aboutUs.offer_details
                    .map((e, i) => (
                      <div className="px-2 overflow-hidden" key={e.id}>
                        <Card
                          cardType="Heading"
                          title={e?.name}
                          img={e?.image1}
                          click={() => offerClick(e)}
                        />
                      </div>
                    ))
                    .slice(0, 4)}
              </>
            )}
          </div>
        </div>
      </div>
      {/* <Footer /> */}
      <Footer />
    </>
  );
};

export default About;
